import {
    FiHome,
    FiShoppingBag,
    FiFolder,
    FiUploadCloud,
    FiTag,
    FiDollarSign,
    FiUsers,
    FiGift,
    FiSend,
    FiMessageSquare,
    FiShield,
    FiSettings,
} from "react-icons/fi";

/**
 * Single source of truth for navigation. Used by the Sidebar, the Topbar
 * breadcrumb and the command-palette search so labels never drift.
 */
export const MENU_GROUPS = [
    {
        id: "main",
        label: null,
        items: [
            { id: "dashboard", label: "Dashboard", icon: FiHome },
            { id: "toko", label: "Manajemen Toko", icon: FiShoppingBag },
            { id: "files", label: "File Manager", icon: FiFolder },
            { id: "update", label: "Update Program", icon: FiUploadCloud },
            { id: "pricing", label: "Pricing", icon: FiTag },
        ],
    },
    {
        id: "transactions",
        label: "Transactions",
        items: [
            { id: "pembayaran", label: "Pembayaran", icon: FiDollarSign },
            { id: "referal", label: "Referal", icon: FiUsers },
            { id: "penarikan", label: "Penarikan", icon: FiGift },
        ],
    },
    {
        id: "communication",
        label: "Communication",
        items: [
            { id: "broadcast", label: "Broadcast", icon: FiSend },
            { id: "livechat", label: "Live Chat", icon: FiMessageSquare },
        ],
    },
    {
        id: "system",
        label: "System",
        items: [
            { id: "security", label: "Keamanan", icon: FiShield },
            { id: "settings", label: "Pengaturan", icon: FiSettings },
        ],
    },
];

export const MENU_BY_ID = MENU_GROUPS.reduce((acc, group) => {
    group.items.forEach((item) => {
        acc[item.id] = { ...item, group: group.label };
    });
    return acc;
}, {});

export const ALL_MENU_ITEMS = MENU_GROUPS.flatMap((g) => g.items);
